<template>
  <div class="final-payment-modal-template">
    <p
      v-for="(text, index) in paragraphs"
      :key="index"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FinalPaymentModalTemplate',
  computed: {
    paragraphs () {
      return [
        this.$t('hint.finalPaymentModal.acceptingFinalPayment'),
        this.$t('hint.finalPaymentModal.irreversibleAcceptanceWarning'),
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.final-payment-modal-template {
  font-size: 14px;
  line-height: 1.5;
  color: #0c3a58;
  font-weight: 700;
  p {
    margin: 0 0 12px;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
</style>
